/**
 * Centralized color palette for the app.
 * 
 * ORGANIZATION:
 * Colors are organized into logical groups in separate files under colorGroups/
 * Each group file exports color objects with light/dark variants.
 * 
 * USAGE in screenThemes.ts:
 * import { buttonColors } from './colorGroups/button.colors';
 * backgroundColor: buttonColors.primary.light
 * 
 * THEMING BENEFIT:
 * Change a color once in its group file, and it automatically updates everywhere!
 */

// Re-export all color groups for easy importing
export { commonColors } from './colorGroups/common.colors';
export { loginColors } from './colorGroups/login.colors';
export {
  buttonColors,
  inputColors,
  checkboxColors,
  dropdownColors,
  searchInputColors,
  calenderColors,
  uiColors
} from './colorGroups/ui.colors';
export {
  eyeColors,
  helpColors,
  languageColors,
  dashboardMenuColors,
  helpMenuColors,
  profileMenuColors,
  notificationMenuColors,
  logoutColors,
  iconColors
} from './colorGroups/icons.colors';
export {
  forgotPasswordColors,
  securityQuestionColors,
  passwordValidationColors,
  pinAuthColors,
  pinInputColors
} from './colorGroups/auth.colors';
export { workOrderColors } from './colorGroups/workOrder.colors';
export {
  scoreBoardColors,
  statusChartColors,
  statusPieChartColors,
  leaderBoardColors,
  leaderRankColors,
  repairBoardColors
} from './colorGroups/dashboard.colors';
export {
  listViewColors,
  listPaginationColors,
  priorityColors,
  statusColors
} from './colorGroups/listView.colors';
export { shopHomeColors } from './colorGroups/shopHome.colors';
export { novaAIColors } from './colorGroups/novaAI.colors';
export {
  menuLayoutColors,
  mainLayoutColors,
  indirectActivityColors,
  selectedShopColors
} from './colorGroups/menu.colors';
export {
  technicianStatusColors,
  shiftStatusColors,
  beginShiftColors,
  endShiftColors,
  detailColors,
  viewAllColors
} from './colorGroups/misc.colors';

// Keep old default export for any legacy code that might still use it
// This can be removed once screenThemes.ts is fully refactored
import { buttonColors } from './colorGroups/button.colors';
import { commonColors } from './colorGroups/common.colors';

const Colors = {
  // Minimal backward compatibility - will be removed after refactor
  white: commonColors.white.light,
  black: commonColors.black.light,
  primaryLight: buttonColors.primary.light,
  primaryDark: buttonColors.primary.dark,
  transparent: commonColors.transparent.light,
};

export default Colors;
